//TODO: ONCE MIGRATED DELETE THIS TABLE
import React from "react";

import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
import {saveOffer, deleteSaveOffer} from 'services/offer_service'

// Saved offers Map : OfferId: SaveOfferID. Used for deletion.
function App({ isReadOnly = false, offerList, savedOffers = new Map(), setSavedOffers}) {

  return (
    <div className="geral">
      <div className="columns">
        <table className="table fullwidth">
          <thead>
            <tr>
              <th>
                <abbr title="Position">Clube</abbr>
              </th>
              <th>
                <abbr title="Played">Escalão</abbr>
              </th>
              <th>
                <abbr title="Won">Função</abbr>
              </th>
              <th>
                <abbr title="Won">Posição</abbr>
              </th>
              <th>
                <abbr title="Drawn">Data da Publicação</abbr>
              </th>
              <th>
                <abbr title="Drawn">nº Candidaturas</abbr>
              </th>
               <th>
                <abbr title="Drawn">Ações</abbr>
              </th>
            </tr>
          </thead>
          <tbody>
            {offerList.map((offer, index) => (
              <tr key={index}>
                <td><Link to={"/conta/"+offer.attributes?.creator?.data?.id}>{offer.attributes?.creator?.data?.attributes?.name}</Link></td>
                <td>{offer.attributes.level}</td>
                <td>{offer.attributes.sub_role ? offer.attributes.sub_role : offer.attributes.role}</td>
                <td>{offer.attributes.player_position}</td>
                <td>{offer.attributes.status === 'Publicado' ? offer.attributes.publication_date : ''}</td>
                <td>{offer?.attributes?.job_offer_applies?.data.length}</td>
                <td>
                  
                  { !savedOffers.has(offer.id) ? 
                    <i className="fas fa-save" onClick={ async () => {
                      let data = await saveOffer(offer.id);
                      savedOffers.set(offer.id, data.id);
                      
                      const deepCopy = new Map(
                        JSON.parse(
                         JSON.stringify(Array.from(savedOffers))
                        )
                      );

                      setSavedOffers(deepCopy)} }></i> : 
                    <i style={{"color": "blue"}} className="fas fa-save" onClick={async () => {
                      await deleteSaveOffer(savedOffers.get(offer.id));
                      savedOffers.delete(offer.id);

                      const deepCopy = new Map(
                        JSON.parse(
                         JSON.stringify(Array.from(savedOffers))
                        )
                      );
                      setSavedOffers(deepCopy) }}></i>
                  }
                  
                  &nbsp;&nbsp;
                  <Popup
                    trigger={<i className="fa fa-ellipsis-v"></i>}
                    position="left center"
                    >
                    <div className="dropdown-content">
                      <Link
                        className="dropdown-item"
                        to={`/ofertas/${offer.id}`}
                      >
                        Detalhe da oferta
                      </Link>
                      {localStorage.getItem("role") !== "Clube" && <Link
                        className="dropdown-item"
                        to={`/ofertas/${offer.id}/candidatar`}
                      >
                        Candidatar-me
                      </Link>}
                    </div>
                  </Popup>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default App;
